module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('Solidarity Account')))])]), _vm._v(" "), _c('div', [_c('recharge-account-page')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d6c511"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SolidarityAccount.vue
// module id = 308
// module chunks = 1